import React from "react";

export const CurrentDayCalendarColorContext = React.createContext();